module.exports = __webpack_public_path__ + "static/media/showcase_morning_mobile@3x.5512be0b.png";